import React, { memo } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { rowKey } from '../utils/tableUtils';
import VariableRow from './VariableRow';

const SortableVariableRow = memo((props) => {
  const id = rowKey(props.scope, props.variable.id);
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  // Translate only — full Transform can scale/squash grid rows while dragging.
  const sortableStyle = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.35 : undefined,
    zIndex: isDragging ? 2 : undefined,
  };

  return (
    <VariableRow
      {...props}
      setSortableRef={setNodeRef}
      sortableStyle={sortableStyle}
      dragHandleProps={{ attributes, listeners }}
    />
  );
});

export default SortableVariableRow;
